import { createFeatureSelector, createSelector } from '@ngrx/store';
import { EntitlementsState } from '../types/entitlements.types';

export const selectEntitlementsState = createFeatureSelector<EntitlementsState>('entitlements');

export const selectCurrentUsageFeaturesPlan = createSelector(
  selectEntitlementsState,
  (state: EntitlementsState) => state.currentUsageFeaturesPlan
);

export const selectEntitlementsLoading = createSelector(
  selectEntitlementsState,
  (state: EntitlementsState) => state.loading
);

export const selectSubscriptionActionLoading = createSelector(
  selectEntitlementsState,
  (state: EntitlementsState) => state.subscriptionActionLoading
);

export const selectEntitlementsError = createSelector(
  selectEntitlementsState,
  (state: EntitlementsState) => state.error
);

export const selectSubscription = createSelector(
  selectEntitlementsState,
  (state: EntitlementsState) => state.subscription
);

export const selectCancelAtPeriodEnd = createSelector(
  selectSubscription,
  subscription => subscription?.cancelAtPeriodEnd ?? false
);

export const selectEffectiveUntil = createSelector(
  selectSubscription,
  subscription => subscription?.effectiveUntil ?? null
);

export const selectCanReactivate = createSelector(
  selectSubscription,
  subscription => subscription?.canReactivate ?? false
);

export const selectFeatureUsage = (featureName: string) =>
  createSelector(selectCurrentUsageFeaturesPlan, currentUsageFeaturesPlan => currentUsageFeaturesPlan[featureName]);

export const selectFeatureUsagePercentage = (featureName: string) =>
  createSelector(selectFeatureUsage(featureName), featureUsage => {
    if (!featureUsage || featureUsage.limit === 0) {
      return 0;
    }

    return Math.round((featureUsage.used / featureUsage.limit) * 100);
  });
